import React, { useState } from "react";
import { useField } from "formik";
import SupplierBIOi18nBlock from "./SupplierBIOi18nBlock";
const SupplierBIOi18n = (props) => {
  const [field, meta, helpers] = useField(props.name);
  const { name, value } = field;
  const [show, setShow] = useState(false);
  return (
    <>
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.chinese_zh_man`}
        label='Chinese man BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.arabic_ar`}
        label='Arabic BIO'
        RTL={true}
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.chinese_zh_can`}
        label='Chinese can BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.deutsch_de`}
        label='Deutsch BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.espanol_es`}
        label='Espanol BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.français_fr`}
        label='Français BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.hindi_hi`}
        label='Hindi BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.indonesian_id`}
        label='Indonesian BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.italiano_it`}
        label='Italiano BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.korean_ko`}
        label='Korean BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.portugues_pt`}
        label='Portugues BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.russian_ru`}
        label='Russian BIO'
      />
      <SupplierBIOi18nBlock
        show={show}
        name={`${name}.turkish_tr`}
        label='Turkish BIO'
      />

    <ShowAllButton show={show} onClick={() =>setShow((show) => !show)} />    
    </>
  );
};

const ShowAllButton = ({onClick , show}) => (
    <div className='row'>
    <div className='col-xl-3'></div>
    <div className='col-xl-9'>
      {" "}
      <button
        className='btn-label-brand btn btn-bold'
        type='button'
        onClick={() => onClick()}
      >
        {" "}
        { !show ? ( <>Show All <i className=' flaticon2-arrow-down '></i> </>) : (<>Hide <i className=' flaticon2-arrow-up '></i></> ) }
      </button>
    </div>
  </div>
)

export default SupplierBIOi18n;
